/** @format */
import { defineStore, StoreDefinition } from 'pinia';
import { store } from '@/store';

interface TableState {
	checkColumnList: any[];
}

type Value<T> = {
	[K in keyof T]?: T[K];
};

export const useTableStore: (name: string) => StoreDefinition = (name) =>
	defineStore({
		id: name,
		state: (): TableState => ({
			checkColumnList: [],
		}),
		actions: {
			setState(obj: Value<TableState>) {
				for (const key in obj) {
					if (Object.prototype.hasOwnProperty.call(this, key)) {
						(this as any)[key] = obj[key];
					}
				}
			},
			reset() {
				this.$reset();
			},
		},
	});

// 在组件setup函数外使用
export function useTableStoreWithOut(name): any {
	return useTableStore(name)(store);
}
